"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISortableFields = void 0;
var ISortableFields;
(function (ISortableFields) {
    ISortableFields["EquipmentType"] = "equipmentType";
    ISortableFields["Id"] = "id";
})(ISortableFields || (exports.ISortableFields = ISortableFields = {}));
//# sourceMappingURL=sortable-fields.js.map